
import React, { useCallback, useState, useMemo } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageContainer, ContentWrapper, GlassCard, Header, Title, Subtitle } from '../style/layout';
import TopBar from '../components/TopBar';
import SettingsBars from '../components/SettingsBars';
import BiosenseSignalMonitor from '../components/BiosenseSignalMonitor';
import { useCameras, useDisableZoom } from '../hooks';
import UAParser from 'ua-parser-js';
import { StorageKeys } from '../utils/storage';

const CameraScanContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const CameraScan: React.FC = () => {
    const cameras = useCameras();
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isLicenseValid, setIsLicenseValid] = useState(false);
    const [cameraId, setCameraId] = useState<string>();

    // Logic from App.tsx handling defaults
    React.useEffect(() => {
        if (!cameras?.length) return;
        setCameraId(cameras[0].deviceId);
    }, [cameras]);

    const isMobile = useMemo(() => UAParser(navigator.userAgent).device.type === 'mobile', []);

    useDisableZoom();

    const toggleSettings = useCallback(() => {
        setIsSettingsOpen((prev) => !prev);
    }, []);

    const handleCloseSettings = useCallback(({ cameraId }: { cameraId?: string } = {}) => {
        if (cameraId) setCameraId(cameraId);
        setIsSettingsOpen(false);
    }, []);

    const updateLicenseStatus = useCallback((valid: boolean) => {
        setIsLicenseValid(valid);
    }, []);

    return (
        <PageContainer>
            <TopBar onSettingsClick={toggleSettings} isMeasuring={false} />

            <SettingsBars
                open={isSettingsOpen}
                onClose={handleCloseSettings}
                cameras={cameras}
                isLicenseValid={isLicenseValid}
            />

            <ContentWrapper>
                <Header>
                    <Title>Vital Health Scan</Title>
                    <Subtitle>Align your face within the frame and stay still for an accurate health assessment</Subtitle>
                </Header>

                <GlassCard>
                    <CameraScanContent>
                        <BiosenseSignalMonitor
                            showMonitor={!(isMobile && isSettingsOpen)}
                            cameraId={cameraId}
                            onLicenseStatus={updateLicenseStatus}
                            onSettingsClick={toggleSettings}
                            isSettingsOpen={isSettingsOpen}
                        />
                    </CameraScanContent>
                </GlassCard>
            </ContentWrapper>
        </PageContainer>
    );
};


export default CameraScan;
